import { gql } from '@apollo/client/core';

export const GET_SCHOOL_GRADE_GROUPS = gql`
  query GetSchoolGradeGroups {
    getSchoolGradeGroups {
      id
      name
      description
      gradeBands {
        id
        name
        grade
        minimum
        maximum
        point
        group
      }
    }
  }
`;
